<div *ngFor="let list of lists">
  <h2>{{list.name}}</h2>
  <mat-list dense>
    <mat-list-item *ngFor="let text of list.data">{{text}}</mat-list-item>
  </mat-list>
</div>